/* AIJ product page layer — Pashupati Jewellers
   Moves the trust pill / ship line / perks rendered by sections/aij-pdp-extras.liquid
   into the product info column, makes Add to Cart shake, and records the product
   for the "Recently viewed" row. It also groups price, options and buttons into a
   "buy box" card and turns option pills (Single / Pair) into large price cards.
   Elements are only moved or wrapped, never rebuilt: the option cards are the theme's
   own <label for=…> elements, so choosing one still clicks the original radio and the
   theme's variant script runs as before. The product form and Fastrr's button are moved
   as whole nodes and never re-created; the phone buy bar only forwards a click to
   Fastrr's own Buy Now button. */
(function () {
  'use strict';
  var KEY = 'aij_recent';

  function record(handle) {
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20)));
    } catch (e) {}
  }

  function init() {
    var src = document.querySelector('[data-aij-pdp]');
    if (!src || src.dataset.done) return;
    src.dataset.done = '1';
    record(src.dataset.handle);

    var info = document.querySelector('.pr-info');
    if (!info) return;

    /* product description starts collapsed unless "Open the product description by
       default" is ticked (the product template renders it open) */
    if (src.dataset.detailsOpen !== 'true') {
      info.querySelectorAll('.pr-acc details[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
    var take = function (sel) { var el = src.querySelector(sel); if (el) el.hidden = false; return el; };

    var trust = take('.aij-pdp-trust');
    var title = info.querySelector('.pr-title');
    if (trust && title) title.parentNode.insertBefore(trust, title);

    var ship = take('.aij-pdp-ship');
    var anchor = info.querySelector('.pr-tax') || info.querySelector('.pr-price');
    if (ship && anchor) anchor.parentNode.insertBefore(ship, anchor.nextSibling);

    var perks = take('.aij-pdp-perks');
    var after = info.querySelector('.pr-eta') || info.querySelector('form');
    if (perks && after) after.parentNode.insertBefore(perks, after.nextSibling);

    if (src.dataset.nocount === 'true') info.classList.add('aij-nocount');

    /* quantity + Add to Cart on one row. The quantity input is tied to the product
       form by its form="" attribute, so moving its box inside the form changes
       nothing that gets submitted. The +/- buttons are forced to type="button" so
       they can never submit the form once they sit inside it. */
    var box = info.querySelector('.pr-qty__box');
    var add = info.querySelector('.pr-actions .pr-btn--add');
    if (box && add && !(add.parentNode && add.parentNode.classList.contains('aij-buyrow'))) {
      box.querySelectorAll('button').forEach(function (b) { b.setAttribute('type', 'button'); });
      var row = document.createElement('div');
      row.className = 'aij-buyrow';
      add.parentNode.insertBefore(row, add);
      row.appendChild(box);
      row.appendChild(add);
      info.classList.add('aij-has-buyrow');
    }

    if (src.dataset.shake === 'true') {
      var btn = info.querySelector('.pr-btn--add');
      if (btn && !btn.disabled) btn.classList.add('aij-shake');
    }

    topRow(info, trust);
    if (src.dataset.buybox === 'true') buyBox(info, src);
    if (src.dataset.cards === 'true') optionCards(info, src);
    savePill(info, src);
    buyBar(info);
  }

  /* trust pill + star rating side by side above the title */
  function topRow(info, trust) {
    var rating = info.querySelector('.pr-rating');
    var title = info.querySelector('.pr-title');
    if (!title || info.querySelector('.aij-pdp-top')) return;
    var row = document.createElement('div');
    row.className = 'aij-pdp-top';
    title.parentNode.insertBefore(row, title);
    if (trust) row.appendChild(trust);
    if (rating) row.appendChild(rating);
  }

  /* one white card: price, options, qty + Add to Cart, Buy Now, ship line, delivery
     estimate and a payment note. The moving strip and the perk row sit below it. */
  function buyBox(info, src) {
    if (info.querySelector('.aij-buybox')) return;
    var price = info.querySelector('.pr-price');
    var form = info.querySelector('form.shopify-product-form') || info.querySelector('form[action*="/cart/add"]');
    if (!price || !form) return;
    var box = document.createElement('div');
    box.className = 'aij-buybox';
    price.parentNode.insertBefore(box, price);
    var move = function (el) { if (el && el.parentNode) box.appendChild(el); };
    move(price);
    move(info.querySelector('.pr-tax'));
    info.querySelectorAll('.pr-opt').forEach(move);
    move(info.querySelector('.pr-qty'));
    move(form);
    var ship = info.querySelector('.aij-pdp-ship');
    if (ship) { ship.classList.add('aij-pdp-ship--below'); move(ship); }
    move(info.querySelector('.pr-eta'));
    if (src.dataset.payNote) {
      var note = document.createElement('p');
      note.className = 'aij-buybox__note';
      note.textContent = src.dataset.payNote;
      box.appendChild(note);
    }
    var hr = info.querySelector('.pr-hr');
    if (hr) hr.style.display = 'none';

    var after = box;
    var strip = src.querySelector('.aij-pdp-strip');
    if (strip) {
      strip.hidden = false;
      var tr = strip.querySelector('.aij-pdp-strip__track');
      if (tr) tr.style.setProperty('--aij-strip-dur', (parseFloat(src.dataset.stripSpeed) || 26) + 's');
      box.parentNode.insertBefore(strip, box.nextSibling);
      after = strip;
    }
    var perks = info.querySelector('.aij-pdp-perks');
    if (perks) {
      after.parentNode.insertBefore(perks, after.nextSibling);
      perks.classList.add('aij-pdp-perks--row');
    }
    info.classList.add('aij-has-buybox');
  }

  function readJSON(src, sel) {
    var el = src.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  /* the currently chosen value of every option group, in order */
  function chosen(info) {
    return Array.prototype.map.call(info.querySelectorAll('.pr-opt'), function (g) {
      var c = g.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });
  }

  function findVariant(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var k = 0; k < values.length; k++) {
        if (values[k] != null && v.o[k] !== values[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* option pills -> large cards: radio dot, value, small line, badge, price + struck price */
  function optionCards(info, src) {
    var variants = readJSON(src, '[data-aij-variants]') || [];
    var notes = {};
    (readJSON(src, '[data-aij-notes]') || []).forEach(function (line) {
      var parts = String(line).split('|').map(function (x) { return x.replace(/<[^>]*>/g, '').trim(); });
      if (parts[0]) notes[parts[0].toLowerCase()] = { sub: parts[1] || '', badge: parts[2] || '' };
    });
    var groups = info.querySelectorAll('.pr-opt');
    if (!groups.length || !variants.length) return;

    groups.forEach(function (g, gi) {
      var labels = g.querySelectorAll('label.pr-pill');
      if (!labels.length || labels.length > 4 || g.classList.contains('aij-opt--cards')) return;
      g.classList.add('aij-opt--cards');
      labels.forEach(function (lab) {
        var input = document.getElementById(lab.getAttribute('for'));
        if (!input) return;
        var value = input.value;
        var n = notes[value.toLowerCase()] || {};
        lab.classList.add('aij-ocard');
        lab.innerHTML =
          '<span class="aij-ocard__dot" aria-hidden="true"></span>' +
          '<span class="aij-ocard__txt"><span class="aij-ocard__name"></span><span class="aij-ocard__sub"></span></span>' +
          '<span class="aij-ocard__price"><span class="aij-ocard__now"></span><span class="aij-ocard__was"></span></span>';
        lab.querySelector('.aij-ocard__name').textContent = value;
        var sub = lab.querySelector('.aij-ocard__sub');
        if (n.sub) sub.textContent = n.sub; else sub.remove();
        if (n.badge) {
          var b = document.createElement('span');
          b.className = 'aij-ocard__badge';
          b.textContent = n.badge;
          lab.appendChild(b);
        }
        lab.dataset.aijValue = value;
        lab.dataset.aijGroup = gi;
      });
    });

    function paint() {
      var sel = chosen(info);
      info.querySelectorAll('.aij-ocard').forEach(function (lab) {
        var gi = +lab.dataset.aijGroup;
        var want = sel.slice(); want[gi] = lab.dataset.aijValue;
        var v = findVariant(variants, want);
        lab.querySelector('.aij-ocard__now').textContent = v ? v.price : '';
        lab.querySelector('.aij-ocard__was').textContent = v && v.compare ? v.compare : '';
        lab.classList.toggle('is-off', !!(v && !v.ok));
      });
    }
    paint();
    info.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') setTimeout(paint, 0); });
  }

  /* "You save Rs. X · Y% off" next to the price, kept in step with the chosen variant */
  function savePill(info, src) {
    var price = info.querySelector('.pr-price');
    var variants = readJSON(src, '[data-aij-variants]') || [];
    if (!price || !variants.length || info.querySelector('.aij-save-pill')) return;
    var pill = document.createElement('span');
    pill.className = 'aij-save-pill';
    price.appendChild(pill);   /* the theme only rewrites the inner price spans, never this row */
    function sync() {
      var v = findVariant(variants, chosen(info)) || variants[0];
      if (v && v.save) {
        pill.textContent = 'You save ' + v.save + (v.pct ? ' · ' + v.pct + '% off' : '');
        pill.hidden = false;
        info.classList.add('aij-has-save');
      } else {
        pill.hidden = true;
        info.classList.remove('aij-has-save');
      }
    }
    sync();
    info.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') setTimeout(sync, 0); });
  }

  /* phone sticky bar: product name, price and Buy Now. It appears while the real
     buttons are off screen; its button clicks Fastrr's button, so checkout runs
     exactly as if the shopper had pressed Buy Now in the product form. */
  function buyBar(info) {
    if (document.querySelector('.aij-mbar')) return;
    var actions = info.querySelector('.pr-actions');
    var title = info.querySelector('.pr-title');
    if (!actions || !title) return;
    var real = function () { return actions.querySelector('.shiprocket-headless .sr-headless-checkout'); };

    var bar = document.createElement('div');
    bar.className = 'aij-mbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="aij-mbar__info"><p class="aij-mbar__name"></p>' +
      '<div class="aij-mbar__price"><span class="aij-mbar__now"></span><span class="aij-mbar__was"></span></div></div>' +
      '<button type="button" class="aij-mbar__btn" tabindex="-1"><span>Buy Now</span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('.aij-mbar__btn');
    bar.querySelector('.aij-mbar__name').textContent = title.textContent.trim();

    function sync() {
      var now = info.querySelector('.pr-price__now'), was = info.querySelector('.pr-price__was');
      bar.querySelector('.aij-mbar__now').textContent = now ? now.textContent.trim() : '';
      var w = bar.querySelector('.aij-mbar__was');
      w.textContent = was && was.offsetParent !== null ? was.textContent.trim() : '';
      var add = actions.querySelector('.pr-btn--add');
      var out = !real() || (add && add.disabled);
      btn.disabled = out;
      btn.firstChild.textContent = out && add && add.disabled ? 'Sold out' : 'Buy Now';
    }
    sync();
    var price = info.querySelector('.pr-price');
    if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(actions, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

    btn.addEventListener('click', function () { var r = real(); if (r && !btn.disabled) r.click(); });

    var phone = window.matchMedia('(max-width: 749px)');
    var show = function (on) {
      on = on && phone.matches;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('aij-mbar-on', on);
    };
    if ('IntersectionObserver' in window) {
      var seen = true;
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; show(!seen); }).observe(actions);
      if (phone.addEventListener) phone.addEventListener('change', function () { show(!seen); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
